export default __webpack_public_path__ + "static/media/2-people-Audio-Video-conference.5910cd5a.svg";